// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__AQzTr","consentsList":"PatientConsents_consentsList__31hfV","consentsListEmpty":"PatientConsents_consentsListEmpty__2w5wu"};